export const sparkedAddressSelector = ({sparkedAddress}) => sparkedAddress